module.exports = __webpack_public_path__ + "img/ime_plus.9aec061f.svg";